import { ICONS } from './icons';

let CACHED_MAP: Map<string, string>;

export function getIconMap(): Map<string, string> {
  if (!CACHED_MAP) {
    // Initialize with built-in icons
    CACHED_MAP = new Map(Object.entries(ICONS));

    // Allow runtime additions via window (optional for custom icons)
    const win = window as any;
    win.Laricons = win.Laricons || {};
    win.Laricons.map = CACHED_MAP;
  }
  return CACHED_MAP;
}

export function addIcons(icons: {[name: string]: string }) {
  const map = getIconMap();
  Object.keys(icons).forEach(name => {
    map.set(name, icons[name]);
  });
}
